<script setup lang="ts">
import CreatePaymentTab from "./CreatePaymentTab.vue";
import CreatePaymentAgentTab from "./CreatePaymentAgentTab.vue";
import CreatePaymentViewController from "@/targets/light/views/create-payment/ts/CreatePaymentViewController";
import { PaymentFlow } from "@/targets/light/types";

const viewController = CreatePaymentViewController.of();

const {
	currency,
	selectedPaymentFlow,
	selectedAgent,
	routerService,
	isFlowRangesLoading,
	isPaymentFlowError,
	calculatedFlowRangesByFirebase,
} = viewController;

const handleSelectFlow = (value: PaymentFlow) => {
	if (selectedPaymentFlow.value === PaymentFlow.AGENT) {
		viewController.resetAgent();
	}

	viewController.setPaymentFlow(value);
}

const handleSelectAgent = async () => {
	routerService.toViewSelectAgentForLight();
}
</script>

<template>
	<div class="create-payment-tabs">
		<CreatePaymentTab
			type="card"
			:currency="currency"
			:ranges="calculatedFlowRangesByFirebase?.card ?? null"
			:loading="isFlowRangesLoading"
			:selected="selectedPaymentFlow === PaymentFlow.CARD"
			:is-error="selectedPaymentFlow === PaymentFlow.CARD && isPaymentFlowError"
			@selected="() => handleSelectFlow(PaymentFlow.CARD)"
		/>
		<CreatePaymentTab
			type="sbp"
			:currency="currency"
			:ranges="calculatedFlowRangesByFirebase?.sbp ?? null"
			:loading="isFlowRangesLoading"
			:selected="selectedPaymentFlow === PaymentFlow.SBP"
			:is-error="selectedPaymentFlow === PaymentFlow.SBP && isPaymentFlowError"
			@selected="() => handleSelectFlow(PaymentFlow.SBP)"
		/>
		<CreatePaymentAgentTab
			:agent="selectedAgent"
			:currency="currency"
			:ranges="calculatedFlowRangesByFirebase?.total ?? null"
			:loading="isFlowRangesLoading"
			:selected="selectedPaymentFlow === PaymentFlow.AGENT"
			:is-error="selectedPaymentFlow === PaymentFlow.AGENT && isPaymentFlowError"
			@selected="handleSelectAgent"
		/>
	</div>
</template>

<style scoped lang="scss">
.create-payment-tabs {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: .75rem;

	&:deep(.create-payment-tab) {
		&:nth-child(1) {
			grid-column: 1 / 2;
			grid-row: 1 / 2;
		}

		&:nth-child(2) {
			grid-column: 2 / 3;
			grid-row: 1 / 2;
		}
	}

	&:deep(.create-payment-agent-tab) {
		grid-column: 1 / 3;
		grid-row: 2 / 3;
	}
}
</style>
